import { getCitiesService } from "../../../services/userServices";

export const setCitiesAction = (cities) => {
  return async (dispatch) => {
    if (cities) {
      await dispatch({
        type: "SET_CITIES",
        payload: cities?.map((_item) => ({
          ..._item,          // <--- Inject all original fields (polygon, center_lat, etc.)
          label: _item.name, // Keep label for dropdown components
          value: _item.id,   // Keep value for dropdown components
        })),
      });
    } else {
      try {
        const { status, data } = await getCitiesService();
        if (status === 200) {
          await dispatch({
            type: "SET_CITIES",
            payload: data.results?.map((_item) => ({
              ..._item,          // <--- Inject all original fields here too
              label: _item.name,
              value: _item.id,
            })),
          });
        }
      } catch ({ response }) {
        console.log("Karbama Cities Error:", response);
      }
    }
  };
};

export const clearCitiesAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_CITIES", payload: {} });
  };
};
